import { SvgIconProps } from "../types";

export const IconImage = ({ src, width, height }: SvgIconProps) => (
  <img src={`/img/icons/${src}`} alt={src} width={width} height={height} style={{margin: '10px 5px 0 0'}}/>
);
